import React from "react";
import type { FunctionComponent, SVGProps } from "react";

import type {
	ButtonProps,
	ComponentWithAs,
	IconProps,
	BoxProps} from "@chakra-ui/react";
import {
	Icon,
	useMediaQuery,
} from "@chakra-ui/react";

import type { IPropsText } from "../../components/Text";
import type { IPropsTitle } from "../../components/Title";
import { minWidth800BP } from "../../constants";
import { ButtonFixedLayout } from "../ButtonFixedLayout";
import { DataCard } from "../DataCard";

interface IProps {
	data: {
		title: string;
		description: string;
	};
	icon?: {
		icon:
		| ComponentWithAs<"svg", IconProps>
		| FunctionComponent<SVGProps<SVGSVGElement>>;
		w: number;
		color: string;
	};
	primaryButton: ButtonProps;
	secondaryButton?: ButtonProps;
	children?: JSX.Element;
	styleProps?: React.CSSProperties;
	isTextUnderIcon?: boolean;
	dataCardStyle?: {
		titleProps?: IPropsTitle;
		textProps?: IPropsText;
		boxPropx?: BoxProps;
	};
}

export const FeedbackOnlyText: React.FC<IProps> = (props) => {
	const {
		secondaryButton,
		primaryButton,
		icon,
		data,
		children,
		styleProps,
		isTextUnderIcon,
		dataCardStyle,
	} = props;
	const { title, description } = data;
	const [isLargerThan800] = useMediaQuery(minWidth800BP);

	return (
		<ButtonFixedLayout
			primaryButton={primaryButton}
			secondaryButton={secondaryButton}
			isFixed
		>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					alignItems: `${isLargerThan800 ? "center" : "flex-start"}`,
					...styleProps,
				}}
			>
				<Icon
					as={icon?.icon}
					color={icon?.color}
					w={icon?.w}
					fill={icon?.color}
					h={icon?.w}
					mb={5}
				/>
				{isTextUnderIcon && children}
				<DataCard
					textProps={{preset: "preset3", ...dataCardStyle?.textProps}}
					titleProps={{...dataCardStyle?.titleProps}}
					title={title}
					description={description}
				/>
				{!isTextUnderIcon && children}
			</div>
		</ButtonFixedLayout>
	);
};
